import React from "react";
import Typography from "@mui/material/Typography";
import { format, parse } from "date-fns";
import { Box, useTheme } from "@mui/material";

function convertToAmPm(timeString) {
    try {
        const parsedTime = parse(timeString, "HH:mm", new Date());
        const formattedTime = format(parsedTime, "h:mm a");
        return formattedTime;
    } catch (error) {
        return "Invalid time format";
    }
}
function formatSchedule(scheduleData) {
    const startDate = format(new Date(scheduleData.startDate), "MMM dd, yyyy");
    const endDate = format(new Date(scheduleData.endDate), "MMM dd, yyyy");

    const startTime = convertToAmPm(scheduleData.startTime);
    const endTime = convertToAmPm(scheduleData.endTime);

    const daysMap = {
        0: "Sun",
        1: "Mon",
        2: "Tue",
        3: "Wed",
        4: "Thu",
        5: "Fri",
        6: "Sat"
    };

    const days = scheduleData.weekDays
        .split("")
        .map((day) => daysMap[day])
        .join(", ");

    return { startDate, endDate, startTime, endTime, days };
}

function ScheduleCard({ schedule }) {
    const formattedSchedule = formatSchedule(schedule);
    const theme = useTheme();

    return (
        <Box
            sx={{
                width: 300,
                borderRadius: 1,
                padding: 1,
                marginBottom: 1,
                bgcolor: theme.palette.primary.light
            }}
        >
            <Typography variant="body2" color="text.secondary">
                <strong>Dates:</strong> {formattedSchedule.startDate} –{" "}
                {formattedSchedule.endDate}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Times:</strong> {formattedSchedule.startTime} –{" "}
                {formattedSchedule.endTime}{" "}
            </Typography>

            <Typography variant="body2" color="text.secondary">
                <strong>Days:</strong> {formattedSchedule.days}
            </Typography>
        </Box>
    );
}

export default ScheduleCard;
